// Page Transition Lock
import { StateCreator } from "zustand";

export interface PageTransitionStateSlice {
  isTransitioning: boolean;
  setTransitioning: (v: boolean) => void;
}

export const pageTransitionStateSlice: StateCreator<
  PageTransitionStateSlice
> = (set) => ({
  isTransitioning: false,
  setTransitioning: (v) => set({ isTransitioning: v }),
});
